/**
 * AP · Size chart riêng cho sản phẩm nhiều option size (bundle).
 *
 * Vì sao không dùng app: MP Size Chart chỉ chèn được ĐÚNG MỘT nút và một modal
 * cho mỗi sản phẩm. Bundle có "Dress Size" và "Leggings Size" là hai dải size
 * khác nhau, lại còn hai kiểu váy lệch nhau ở cột Length, nên cần hai nút mở
 * hai bảng khác nhau. Bảng nằm ở assets/ap-size-charts.json.
 */
(() => {
  const SRC = document.currentScript?.dataset.src;
  if (!SRC) return;

  /** @type {Promise<any> | null} */
  let loading = null;
  const load = () => (loading ??= fetch(SRC).then((r) => r.json()));

  const esc = (v) => String(v).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  // Hình đo là SVG do theme vẽ, nằm sẵn trong JSON — không gọi ảnh ngoài.
  const renderTable = (t) => `
    <div class="ap-scx__block">
      <div class="ap-scx__name">${esc(t.name)}</div>
      <div class="ap-scx__scroll">
        <table class="ap-scx__table">
          <thead><tr>${t.columns.map((c) => `<th>${esc(c)}</th>`).join('')}</tr></thead>
          <tbody>${t.rows.map((r) => `<tr>${r.map((c) => `<td>${esc(c)}</td>`).join('')}</tr>`).join('')}</tbody>
        </table>
      </div>
      ${t.diagram ? `<div class="ap-scx__diagram">${t.diagram}</div>` : ''}
    </div>`;

  const dialog = () => document.querySelector('dialog.ap-scx');
  // iOS < 15.4 / old in-app browsers have no dialog.close(): fall back to the attribute the open path already uses
  const closeDlg = (d) => { if (!d) return; if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); };

  async function open(key, label) {
    const dlg = dialog();
    if (!dlg) return;
    const body = dlg.querySelector('[data-ap-scx-body]');
    const title = dlg.querySelector('[data-ap-scx-title]');
    if (!body || !title) return;

    title.textContent = label || 'Size chart';
    body.innerHTML = '<p class="ap-scx__loading">Loading size chart…</p>';
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');

    try {
      const data = await load();
      const chart = data?.charts?.[key];
      if (!chart) throw new Error('missing chart: ' + key);
      title.textContent = chart.title || label || 'Size chart';
      body.innerHTML =
        chart.tables.map(renderTable).join('') +
        (chart.note ? `<p class="ap-scx__note">${esc(chart.note)}</p>` : '');
    } catch (e) {
      body.innerHTML = '<p class="ap-scx__note">Size chart could not be loaded. Please try again.</p>';
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const btn = target?.closest('[data-ap-scx-open]');
    if (btn) {
      event.preventDefault();
      open(btn.getAttribute('data-ap-scx-open') || '', btn.getAttribute('data-ap-scx-label') || '');
      return;
    }
    if (target?.closest('[data-ap-scx-close]')) {
      closeDlg(dialog());
      return;
    }
    // bấm ra ngoài khung thì đóng
    const dlg = dialog();
    if (dlg?.open && target === dlg) closeDlg(dlg);
  });
})();
